export default __webpack_public_path__ + "static/media/120.510ad110.png";